/**
 * <s-site-header> — scroll-aware chrome.
 * Sets on itself:
 *   data-scrolled  once the page has moved past the top (pine + blur + orange rule)
 *   data-hidden    while scrolling down past the fold; removed on any scroll up
 * Never hides while focus is inside the header, so keyboard users keep it in view.
 * Reduced motion keeps the state changes but CSS drops the slide.
 */
class SSiteHeader extends HTMLElement {
  connectedCallback() {
    this.lastY = window.scrollY;
    this.ticking = false;
    this.onScroll = () => {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    };
    this.onFocusIn = () => this.removeAttribute('data-hidden');
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.addEventListener('focusin', this.onFocusIn);
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.removeEventListener('focusin', this.onFocusIn);
  }

  update() {
    const y = Math.max(window.scrollY, 0);
    const delta = y - this.lastY;
    this.toggleAttribute('data-scrolled', y > 16);
    if (y < this.offsetHeight * 2) {
      this.removeAttribute('data-hidden');
    } else if (delta > 6 && !this.contains(document.activeElement)) {
      this.setAttribute('data-hidden', '');
    } else if (delta < -6) {
      this.removeAttribute('data-hidden');
    }
    this.lastY = y;
  }
}

if (!customElements.get('s-site-header')) customElements.define('s-site-header', SSiteHeader);
